export const menuData = [
    {
        title: 'Home', link:'/'
    },
    {
        title: 'About', link:'/about'
    },
    {
        title: 'Services', link:'/services'
    },
];